import { render } from "./GreetingsAndPhrases.vue?vue&type=template&id=6606ee9b&scoped=true"
import script from "./GreetingsAndPhrases.vue?vue&type=script&lang=js"
export * from "./GreetingsAndPhrases.vue?vue&type=script&lang=js"

import "./GreetingsAndPhrases.vue?vue&type=style&index=0&id=6606ee9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6606ee9b"]])

export default __exports__